export default __webpack_public_path__ + "static/media/kiara2.92990ad1.jpg";